import { useQuery } from '@apollo/client';
import { useMemo } from 'react';
import { GET_FINANCIAL_DATA_AVAILABILITY } from '../graphql/queries/financialData';

interface UseFinancialDataAvailabilityResult {
  hasFinancialData: boolean;
  hasPLData: boolean;
  hasBalanceSheetData: boolean;
  availablePeriods: number[];
  loading: boolean;
  error?: any;
}

export const useFinancialDataAvailability = (companyId: number | null): UseFinancialDataAvailabilityResult => {
  const { data, loading, error } = useQuery(GET_FINANCIAL_DATA_AVAILABILITY, {
    variables: { companyId },
    skip: !companyId,
    fetchPolicy: 'cache-first', // Use cache for efficiency
  });

  const result = useMemo(() => {
    if (!data?.getFinancialDataAvailability) {
      return {
        hasFinancialData: false,
        hasPLData: false,
        hasBalanceSheetData: false,
        availablePeriods: [],
        loading,
        error,
      };
    }

    const { hasPLData, hasBalanceSheetData, availablePeriods } = data.getFinancialDataAvailability;

    return {
      hasFinancialData: hasPLData || hasBalanceSheetData,
      hasPLData,
      hasBalanceSheetData,
      availablePeriods: availablePeriods || [],
      loading,
      error,
    };
  }, [data, loading, error]);

  return result;
};
